import { SUB_SERVICE_ORDER_STATUS } from '../constants'

export const statusFilterOptions = [
  { value: SUB_SERVICE_ORDER_STATUS.ALL, label: 'ALL' },
  { value: SUB_SERVICE_ORDER_STATUS.NEW, label: 'NEW' },
  { value: SUB_SERVICE_ORDER_STATUS.IN_PROGRESS, label: 'IN_PROGRESS' },
  { value: SUB_SERVICE_ORDER_STATUS.COMPLETED, label: 'COMPLETED' },
  { value: SUB_SERVICE_ORDER_STATUS.CANCELLED, label: 'CANCELLED' },
]
